import { SiApple } from '@react-icons/all-files/si/SiApple';
import { SiGoogleplay } from '@react-icons/all-files/si/SiGoogleplay';
import React from 'react';
import { StylableProp } from '../../utils/stylable-prop';

interface StoreBtnProps {
  store: 'apple' | 'google';
  url: string;
  darkMode?: boolean;
  id: 'btn_app_store' | 'btn_play_store';
}

export default function StoreBtn({
  store,
  darkMode,
  url,
  className,
  id
}: StylableProp<StoreBtnProps>) {
  const text = store === 'apple' ? 'Download on the' : 'Get it on';
  const storeTitle = store === 'apple' ? 'App Store' : 'Google Play';
  const icon = store === 'apple' ? <SiApple /> : <SiGoogleplay />;

  return (
    <a
      href={url}
      target="_blank"
      className={
        `flex w-44 items-center rounded-md border border-gray-500 py-2 pl-3 no-underline` +
        `transition-all ease-[cubic-bezier(0.19,1.59,0.6,1.46)] hover:scale-105 ` +
        `bg-transparent text-black dark:bg-black dark:text-white ` +
        `hover:bg-black hover:text-white hover:dark:bg-transparent hover:dark:text-black ` +
        `${className}`
      }
      id={id}
    >
      <span className={'icon ml-1 text-4xl'}>{icon}</span>
      <span className={'text mx-1' + ' flex flex-col text-left  leading-none'}>
        <span className="text-xs">{text}</span>
        <strong className="text-sm">{storeTitle}</strong>
      </span>
    </a>
  );
}
